export default __webpack_public_path__ + "static/media/taxis.6a0d84d9.png";